var _path, _rect, _mask, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecureIconWhite = function SvgSecureIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M10 12a8.5 8.5 0 0 1 17 0v3.5H10z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17,
    x: 6,
    y: 15.5,
    stroke: "#fff",
    strokeWidth: 3,
    rx: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "secureIconWhite_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10,
    x: 9.5,
    y: 19,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10,
    x: 9.5,
    y: 19,
    stroke: "#fff",
    strokeWidth: 4,
    mask: "url(#secureIconWhite_svg__a)",
    rx: 1
  })));
};
export default SvgSecureIconWhite;